import { render, staticRenderFns } from "./PurchaseOrderStatusBundangHandling.vue?vue&type=template&id=4106f1a2&scoped=true&"
import script from "./PurchaseOrderStatusBundangHandling.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderStatusBundangHandling.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderStatusBundangHandling.vue?vue&type=style&index=0&id=4106f1a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4106f1a2",
  null
  
)

export default component.exports